import { cli, genCode, getP, pcode, stageOf } from '../../core/selectors.js';
import { go, render } from '../../core/shell.js';
import { S, UI, save } from '../../core/store.js';
import { closeModal, toast } from '../../core/ui.js';
import { $, off, uid, val } from '../../core/util.js';
import { createProject, newProjectModal, npPreview } from './create.js';
import { findT } from './detail.js';

export const actions={
tcycle(el){const {t}=findT(el.dataset.p,el.dataset.id);if(!t)return;t.status=t.status==='todo'?'doing':t.status==='doing'?'done':'todo';save();render()},
tdel(el){const {p}=findT(el.dataset.p,el.dataset.id);p.tasks=p.tasks.filter(x=>x.id!==el.dataset.id);save();render()},
openp(el){go('project',{pid:el.dataset.p,ptab:'tasks'})},
ptab(el){UI.ptab=el.dataset.t;render()},
pfilter(el){UI.pf=el.dataset.f;render()},
scrollph(el){const e=document.getElementById('ph-'+el.dataset.ph);if(e)e.scrollIntoView({behavior:'smooth',block:'start'})},
newproj(){newProjectModal()},
npcreate(){
  const sel=val('np-client');let code;const title=val('np-title');if(!title){toast('Give the project a name');return}
  if(sel==='__new'){const n=val('np-newname');if(!n){toast('Add the client name');return}code=(val('np-newcode')||genCode(n)).toUpperCase();if(!cli(code))S.clients.push({code,name:n})}else code=sel;
  const p=createProject(code,title,val('np-due'));closeModal();toast('Created '+pcode(p));go('project',{pid:p.id,ptab:'tasks'});
 },
licreate(){
  const d=S.deals.find(x=>x.id===val('li-id'));const title=val('np-title');const n=val('np-newname');if(!d||!title||!n){toast('Fill in the client and project name');return}
  const code=(val('np-newcode')||genCode(n)).toUpperCase();if(!cli(code))S.clients.push({code,name:n});
  const p=createProject(code,title,val('np-due'));d.stage='won';d.pid=p.id;d.wonAt=off(0);save();closeModal();toast('Locked in as '+pcode(p));render();
 },
pickfile(el){UI.pendPh=el.dataset.ph;$('#fu').click()},
fdel(el){const p=getP(el.dataset.p);p.files=p.files.filter(f=>f.id!==el.dataset.id);save();render()},
pview(el){UI.pview=el.dataset.v;render()},
ptoggle(el){UI.pcol[el.dataset.g]=!UI.pcol[el.dataset.g];render()}
};

export const changes={
ttitle(el){const {t}=findT(el.dataset.p,el.dataset.id);if(t&&el.value.trim()){t.title=el.value.trim();save()}},
twho(el){const {t}=findT(el.dataset.p,el.dataset.id);t.who=el.value;save();render()},
tdue(el){const {t}=findT(el.dataset.p,el.dataset.id);t.due=el.value||null;save();render()},
npchg(){npPreview()},
upload(el){
  const p=getP(UI.pid);[...el.files].forEach(f=>p.files.push({id:uid(),ph:UI.pendPh,name:f.name,size:f.size,by:S.me,at:off(0)}));el.value='';save();render();toast('Attached');
 },
pstage(el){const p=getP(UI.pid);p.stage=el.value;save();render();toast(el.value==='auto'?'Stage now follows tasks':'Moved to '+stageOf(p).name)},
pgroup(el){UI.pg=el.value;render()}
};
